var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.booking && _vm.booking.rent_to_own === true)?_c('v-chip',{staticClass:"rent-to-own-chip",attrs:{"x-small":"","color":"deep-purple","text-color":"white","data-cy":"rent-to-own-chip","aria-label":_vm.$t('rent_to_own.chip_label')}},[_vm._v(" "+_vm._s(_vm.$t("rent_to_own.chip_label"))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }